var map = {
	"./RUV_RGB.png": 25,
	"./RUV_RGB_small.png": 26,
	"./favicon.png": 27,
	"./kolkrabbi.png": 28,
	"./kolkrabbi_big.png": 29,
	"./logo.png": 30,
	"./no-data-no-cry.jpg": 31
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24;